import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';
import { SearchDto } from '../data/models/search-dto';

@Injectable({
  providedIn: 'root'
})
export class AvgDelayDropService {

  url = appUrls.lineDetails;
  constructor(private http: HttpClient) { }

  getLineDelayDropGraphData(lineId: number, IpAddress: string) {
    let obj: SearchDto = { searchKeyword: IpAddress }
    return this.http.post(this.url.getLineDelayDropGraphsData + lineId,obj)
  }
}
